import type { MenuProps, DropdownProps } from "antd";

import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import merge from "lodash/merge";

import { DROPDOWN_PLACEMENT, DROPDOWN_TRIGGER } from "@/constants/Dropdown";

export type SecondaryActionsProps = {
  items: MenuProps["items"];
  dropdownProps?: DropdownProps;
};

const SecondaryActions = ({
  items = [],
  dropdownProps = {},
}: SecondaryActionsProps) => {
  const dropdownDefaultAttributes: DropdownProps = {
    menu: {
      items: [],
    },
    arrow: false,
    placement: DROPDOWN_PLACEMENT.BOTTOM_RIGHT as DropdownProps["placement"],
    trigger: [DROPDOWN_TRIGGER.CLICK] as DropdownProps["trigger"],
  };

  const dropdownAttributes = merge(
    {},
    dropdownDefaultAttributes,
    dropdownProps
  );

  return (
    <Dropdown
      rootClassName="secondary-actions"
      {...dropdownAttributes}
      menu={{ items }}
    >
      <Button>
        <MoreOutlined />
      </Button>
    </Dropdown>
  );
};

export default SecondaryActions;
